import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-5">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-4">
            <h2 className="display-5 fw-bold text-dark mb-4">About Laxmi Tyre & Motors</h2>
            <p className="lead text-muted mb-4">
              Established in 2011, Laxmi Tyre and Motors has been serving the automobile 
              repair and maintenance needs of Indore with dedication and expertise.
            </p>
            <p className="text-muted mb-4">
              We are a trusted car service provider specializing in expert denting and painting 
              services, along with comprehensive vehicle maintenance. Our team of skilled 
              technicians uses modern equipment and genuine parts.
            </p>
          </Col>
          <Col lg={6}>
            <Row>
              <Col sm={6} className="mb-3">
                <Card className="text-center border-0 shadow-sm h-100">
                  <Card.Body>
                    <h3 className="fw-bold text-primary mb-1">13+</h3>
                    <p className="text-muted mb-0">Years Experience</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={6} className="mb-3">
                <Card className="text-center border-0 shadow-sm h-100">
                  <Card.Body>
                    <h3 className="fw-bold text-primary mb-1">5000+</h3>
                    <p className="text-muted mb-0">Happy Customers</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={6} className="mb-3">
                <Card className="text-center border-0 shadow-sm h-100">
                  <Card.Body>
                    <h3 className="fw-bold text-primary mb-1">12</h3>
                    <p className="text-muted mb-0">Services Offered</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={6} className="mb-3">
                <Card className="text-center border-0 shadow-sm h-100">
                  <Card.Body>
                    <h3 className="fw-bold text-primary mb-1">98%</h3>
                    <p className="text-muted mb-0">Satisfaction Rate</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;